module.exports = __webpack_public_path__ + "static/media/stijn-bessem-clients-hedo.21964e46.svg";